//import { Logger } from "./logger";

export class LocalStorageCache
{
    static _storageName = "ai_localStorageCache";

    static getAll()
    {
        let storage = {};
        if(localStorage.getItem(this._storageName) != null)
        {
            storage = JSON.parse(localStorage.getItem(this._storageName));
        }
        return storage;
    }

    static set(value)
    {   
        let storage = {};
        if(localStorage.getItem(this._storageName) != null)
        {
            storage = JSON.parse(localStorage.getItem(this._storageName));
        }
        storage[value.id] = value;
        localStorage.setItem(this._storageName, JSON.stringify(storage))
    }
    static get()
    {
        if(localStorage.getItem(this._storageName) == null)
        {
            return null;
        }
        let storage = JSON.parse(localStorage.getItem(this._storageName));
        let value = null;
        try
        {
            let key = Object.keys(storage)[0];
            value = storage[key];
        }
        catch(ex)
        {
            console.log(ex);//Logger.logError(ex, "LocalStorageCache.get", "", "");
        }
        return value;
    }

    static delete(id)
    {
        if(localStorage.getItem(this._storageName) == null)
        {
            return;
        }
        let storage = JSON.parse(localStorage.getItem(this._storageName));
        delete storage[id];
        localStorage.setItem(this._storageName, JSON.stringify(storage))
    }

    static deleteAll()
    {
        if(localStorage.getItem(this._storageName) == null)
        {
            return;
        }
        localStorage.setItem(this._storageName, JSON.stringify({}))
    }
}



export class UserActionCache extends LocalStorageCache
{
    static _storageName = "ai_userActionCache";
}

export class UserActionAnalyticsCache extends LocalStorageCache
{
    static _storageName = "ai_userActionAnalyticsCache";
}

export class UserActionAnalyticsDeliveryCache extends LocalStorageCache
{
    static _storageName = "ai_userActionAnalyticsDeliveryCache";
}

export class UserPredictionCache extends LocalStorageCache
{
    static _storageName = "ai_userPredictionCache";
}